import { Component, OnInit, ElementRef } from '@angular/core';
//import * as appConfig from './app-config.json';
import { ConfigService, AuthenticationService, AutoLogoutService, DefgIniService } from 'yt-ng-framework';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd, ActivationEnd, NavigationStart, ActivatedRoute } from '@angular/router';
import * as appConfig from './../assets/app-config.json';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(protected configService: ConfigService,
              protected authenticationService: AuthenticationService,
              protected translateService: TranslateService,
              protected autoLogoutService: AutoLogoutService,
              protected router: Router,
              protected titleService: Title,
              protected elementRef: ElementRef,
              protected defgIni: DefgIniService,
              protected activatedRoute: ActivatedRoute
              ){
    //var json = require('./app-config.json');
    this.defgIni.isDefginiSetObservable
                .subscribe(isSet=>{
                  if (isSet) { 
                      var jezik = this.defgIni.GetByKey("g_jezik");
                      
                      const finalLang = jezik ? jezik.toLowerCase() : 'sr'; 
                      
                      this.translateService.setDefaultLang(finalLang);
                      this.translateService.use(finalLang);
                  } else {
                      this.translateService.setDefaultLang('sr');
                      this.translateService.use('sr');
                  }
                })
  }

  isAuthenticated: boolean = false;
  public logoLink = 'https://minibiz.rs/';
  public bazaZnanjaLink = 'https://minibiz.rs/funkcionalnosti/';

  ngOnInit(){
    //this.configService.SetApiUrl(appConfig.default.apiUrl);
    //this.configService.SetRootUrl(appConfig.default.rootUrl);

    //this.authenticationService.Login('admin@yuteam.co.rs', '123456No.');

    this.authenticationService.IsAuthenticated
      .subscribe(isAuthenticated => {
        this.isAuthenticated = isAuthenticated;
        if(!isAuthenticated){
          //this.router.navigate(['login']);
          this.isAuthenticated = isAuthenticated;
          this.elementRef.nativeElement.ownerDocument.body.style.background = 'url("/assets/images/main.jpg") fixed no-repeat';
        }
        else{
          //this.router.navigate(['company-selector'], { queryParams: { returnUrl: '/'}});
          this.elementRef.nativeElement.ownerDocument.body.style.background = 'none';
        }
      })

      let titleSet: boolean = false;
      this.router.events.subscribe(value => {
        if(value instanceof NavigationStart){
          titleSet = false;
          this.titleService.setTitle('YuTeam ERP - Minibiz');
        }
        if(value instanceof ActivationEnd && titleSet == false && value.snapshot.data != null && value.snapshot.data.breadcrumbLabel != null){
          const breadcrumbLabelKey = value.snapshot.data.breadcrumbLabel;
          this.translateService.get(breadcrumbLabelKey)
            .subscribe(translate => {
              this.titleService.setTitle(translate + ' | YuTeam ERP - Minibiz');
              titleSet = true
            })
        }

      })

  }
  //title = 'app';
}
